import React, { useEffect, useRef, useState } from 'react';
import anime from 'animejs';
import PropTypes from 'prop-types';

const FadeInWrapper = ({ children, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          setIsVisible(true);
          hasAnimated.current = true;
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 },
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      anime({
        targets: componentRef.current,
        opacity: [0, 1],
        translateY: [20, 0],
        easing: 'easeInOutSine',
        duration: 300,
        delay,
      });
    }
  }, [isVisible, delay]);

  return (
    <div ref={componentRef} style={{ opacity: 0 }}>
      {children}
    </div>
  );
};

FadeInWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
};

FadeInWrapper.defaultProps = {
  delay: 0,
};

export default FadeInWrapper;
